import React from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconText = ({ icon, text }) => {
  return (
    <div className={container}>
      <div className="circle">
        <FontAwesomeIcon className={'icon ' + icon} icon={icon} />
      </div>
      <p>{text}</p>
    </div>
  );
};

export default IconText;

const container = css`
  color: ${colors.brandColor};
  display: flex;
  margin-right: 16px;
  align-items: center;
  font-size: ${textSizes.normal};
  .icon {
    font-size: 16px;
    
    &.mouse-pointer {
      height: 60%;
      width: 60%;
      left: 58%;
    }
  }
  p {
    padding: 0 6px;
  }

  .circle {
    height: 16px;
    width: 16px;
    background-color: transparent;
    border-radius: 50%;
    color: ${colors.brandColor};
    border: 1px solid ${colors.brandColor};
    position: relative;

    @media screen and (min-width: ${boxStyles.desktopBreak}) {
      height: 20px;
      width: 20px;
    }

    svg {
      height: 50%;
      width: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      &.fa-play {
        margin-left: 1px;
      }
    }
  }
`;
